import api from '../api';

const pathTop = '/lists/top';

export const getTopRentListRequest = () => api.get(`${pathTop}/rent/get`);
export const getTopCompanyListRequest = () => api.get(`${pathTop}/company/get`);
export const getTopServiceListRequest = () => api.get(`${pathTop}/service/get`);
export const getTopPlacementListRequest = () =>
    api.get(`${pathTop}/placement/get`);
export const getTopDealerListRequest = () => api.get(`${pathTop}/dealer/get`);
export const getTopCarListRequest = () => api.get(`${pathTop}/car/get`);
export const getTopBikeListRequest = () => api.get(`${pathTop}/bike/get`);
export const getTopCommercialListRequest = () =>
    api.get(`${pathTop}/commercial/get`);
export const getTopPartsListRequest = () => api.get(`${pathTop}/parts/get`);
